(function () {
  const INIT_FLAG = 'jvEstimativaFreteInited';
  const CALCULATING_ATTR = 'data-jv-frete-calculating';

  function formatCurrency(value) {
    if (value == null || value === '') return 'R$ 0,00';
    const raw = typeof value === 'number' ? String(value) : String(value).trim();
    const num = Number(raw.replace(',', '.'));
    if (!isFinite(num)) return String(value);
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(num);
  }

  function extractDeliveryFromText(text) {
    if (!text) return null;
    const patterns = [
      { regex: /(\d+)\s*(?:a|à|-)\s*(\d+)\s*dias?\s*(?:úteis?|uteis?)/i, fmt: (m) => `${m[1]}-${m[2]} dias úteis` },
      { regex: /(\d+)\s*dias?\s*(?:úteis?|uteis?)/i, fmt: (m) => (parseInt(m[1], 10) === 1 ? '1 dia útil' : `${m[1]} dias úteis`) },
      { regex: /(\d+)\s*(?:a|à|-)\s*(\d+)\s*dias?/i, fmt: (m) => `${m[1]}-${m[2]} dias` },
      { regex: /(\d+)\s*dias?/i, fmt: (m) => (parseInt(m[1], 10) === 1 ? '1 dia' : `${m[1]} dias`) }
    ];
    for (const p of patterns) {
      const m = String(text).match(p.regex);
      if (m) return p.fmt(m);
    }
    return null;
  }

  function formatDeliveryDaysArray(deliveryDays) {
    if (!Array.isArray(deliveryDays) || !deliveryDays.length) return '';
    const last = deliveryDays[deliveryDays.length - 1];
    return last === 1 ? '1 dia útil' : `${last} dias úteis`;
  }

  function computeDeliveryTime(rate) {
    const deliveryRange = rate.delivery_range ? String(rate.delivery_range).trim() : '';
    const deliveryDate = rate.delivery_date ? String(rate.delivery_date).trim() : '';

    if (deliveryRange && deliveryRange !== 'null' && deliveryRange !== 'undefined') {
      if (deliveryRange.includes(',') && deliveryRange.includes('-')) {
        const [startDate, endDate] = deliveryRange.split(',').map((s) => s.trim());
        try {
          const start = new Date(startDate);
          const end = new Date(endDate);
          const today = new Date();
          const diffStart = Math.ceil((start - today) / 86400000);
          if (diffStart <= 0) return 'Entrega hoje';
          if (diffStart === 1) return '1 dia útil';
          if (startDate === endDate) return `${diffStart} dias úteis`;
          const diffEnd = Math.ceil((end - today) / 86400000);
          return `${diffStart} a ${diffEnd} dias úteis`;
        } catch {
          return deliveryRange;
        }
      }
      return deliveryRange;
    }

    if (deliveryDate && deliveryDate !== 'null' && deliveryDate !== 'undefined') return deliveryDate;

    if (rate.delivery_estimate_business_days && rate.delivery_estimate_business_days !== 'undefined') {
      const d = parseInt(rate.delivery_estimate_business_days, 10);
      if (d > 0) return d === 1 ? '1 dia útil' : `${d} dias úteis`;
    }

    if (rate.delivery_estimate_transit_time_business_days && rate.delivery_estimate_transit_time_business_days !== 'undefined') {
      const d = parseInt(rate.delivery_estimate_transit_time_business_days, 10);
      if (d > 0) return d === 1 ? '1 dia útil' : `${d} dias úteis`;
    }

    if (rate.delivery_days && Array.isArray(rate.delivery_days) && rate.delivery_days.length > 0) {
      return formatDeliveryDaysArray(rate.delivery_days);
    }

    if (rate.description && rate.description.trim() !== '') {
      return extractDeliveryFromText(rate.description.trim()) || rate.description.trim();
    }

    return extractDeliveryFromText(rate.name) || '';
  }

  function getProductFormData(wrapper) {
    const formId = wrapper?.dataset?.productForm;
    let form = null;

    if (formId) {
      const candidates = document.querySelectorAll('form[data-type="add-to-cart-form"]');
      for (const candidate of candidates) {
        if (candidate.id !== formId) continue;
        if (candidate.closest('product-add-to-cart-sticky') || candidate.closest('.sticky-atc')) continue;
        form = candidate;
        break;
      }
      if (!form) form = document.getElementById(formId);
    }

    if (!form) {
      form = document.querySelector('product-form:not(.sticky-atc) form[data-type="add-to-cart-form"]');
    }
    if (!form) return null;

    const fd = new FormData(form);
    let variantId = fd.get('id');

    if (!variantId) {
      const variantInput =
        form.querySelector('input[name="id"]:not([disabled])') ||
        form.querySelector('input.product-variant-id');
      variantId = variantInput?.value || null;
    }

    const quantityInput =
      document.querySelector(`input[name="quantity"][form="${formId}"]`) ||
      form.querySelector('input[name="quantity"]');
    const quantity = fd.get('quantity') || quantityInput?.value || 1;
    const obj = { id: variantId, quantity: Number(quantity) || 1 };
    const properties = {};

    fd.forEach((v, k) => {
      const m = k.match(/^properties\[(.+)\]$/);
      if (m) properties[m[1]] = v;
    });

    if (Object.keys(properties).length) obj.properties = properties;

    const sellingPlan = fd.get('selling_plan');
    if (sellingPlan) obj.selling_plan = sellingPlan;

    return obj.id ? obj : null;
  }

  function setCalculating(active) {
    if (active) {
      document.documentElement.setAttribute(CALCULATING_ATTR, 'true');
    } else {
      document.documentElement.removeAttribute(CALCULATING_ATTR);
    }
  }

  async function backupCart() {
    const resp = await fetch('/cart.js', { method: 'GET' });
    const cart = await resp.json();
    return (cart.items || []).map((it) => ({
      id: it.variant_id,
      quantity: it.quantity,
      properties: it.properties && Object.keys(it.properties).length ? it.properties : undefined,
      selling_plan: it.selling_plan_allocation?.selling_plan?.id || undefined
    }));
  }

  function normalizeProperties(properties) {
    if (!properties || typeof properties !== 'object') return {};
    const out = {};
    for (const key of Object.keys(properties)) {
      if (key === '_jv_shipping_estimate') continue;
      if (properties[key] == null || properties[key] === '') continue;
      out[key] = String(properties[key]);
    }
    return out;
  }

  function propertiesEqual(a, b) {
    const left = normalizeProperties(a);
    const right = normalizeProperties(b);
    const leftKeys = Object.keys(left);
    const rightKeys = Object.keys(right);
    if (leftKeys.length !== rightKeys.length) return false;
    return leftKeys.every((key) => left[key] === right[key]);
  }

  function sellingPlanEqual(a, b) {
    const left = a ? String(a) : '';
    const right = b ? String(b) : '';
    return left === right;
  }

  function buildCartWithProduct(backupItems, productItem) {
    const items = (backupItems || []).map((item) => {
      const out = {
        id: item.id,
        quantity: Number(item.quantity) || 1
      };
      const props = normalizeProperties(item.properties);
      if (Object.keys(props).length) out.properties = props;
      if (item.selling_plan) out.selling_plan = item.selling_plan;
      return out;
    });

    const matchIndex = items.findIndex(
      (item) =>
        String(item.id) === String(productItem.id) &&
        sellingPlanEqual(item.selling_plan, productItem.selling_plan) &&
        propertiesEqual(item.properties, productItem.properties)
    );

    if (matchIndex >= 0) {
      items[matchIndex].quantity =
        (Number(items[matchIndex].quantity) || 0) + (Number(productItem.quantity) || 1);
    } else {
      const next = {
        id: productItem.id,
        quantity: Number(productItem.quantity) || 1
      };
      const props = normalizeProperties(productItem.properties);
      if (Object.keys(props).length) next.properties = props;
      if (productItem.selling_plan) next.selling_plan = productItem.selling_plan;
      items.push(next);
    }

    return items;
  }

  async function addCartItems(items) {
    if (!items || !items.length) return;
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items: items.map((i) => {
          const out = { id: i.id, quantity: i.quantity };
          if (i.properties && Object.keys(i.properties).length) out.properties = i.properties;
          if (i.selling_plan) out.selling_plan = i.selling_plan;
          return out;
        })
      })
    });
  }

  async function restoreCart(items) {
    await fetch('/cart/clear.js', { method: 'POST' });
    await addCartItems(items);
  }

  async function addTemporaryLine(item) {
    const payload = {
      ...item,
      properties: {
        ...(item.properties || {}),
        _jv_shipping_estimate: '1'
      }
    };

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    });
  }

  function renderRates(ratesData, wrapper, contextNote) {
    const elSucesso = wrapper.querySelector('[data-frete-sucesso]');
    const elAviso = wrapper.querySelector('[data-frete-aviso]');

    if (!ratesData || !ratesData.shipping_rates || !ratesData.shipping_rates.length) {
      if (elAviso) {
        elAviso.innerHTML = '<p class="mb-0">Não foi possível encontrar opções de frete para o CEP informado.</p>';
        elAviso.removeAttribute('hidden');
      }
      return;
    }

    let html = '';
    if (contextNote) {
      html += `<p class="jv-estimativa-frete__context">${contextNote}</p>`;
    }

    for (const rate of ratesData.shipping_rates) {
      const priceText =
        Number(rate.price) === 0
          ? '<p class="frete-gratis-badge">GRÁTIS</p>'
          : formatCurrency(rate.price);
      const delivery = computeDeliveryTime(rate);
      const nameHtml = delivery
        ? `<span class="shipping-name__label">${rate.name}</span><span class="shipping-delivery-time">${delivery}</span>`
        : `<span class="shipping-name__label">${rate.name}</span>`;
      html += `<div class="shipping-option"><div class="shipping-header"><div class="shipping-name">${nameHtml}</div><div class="shipping-price">${priceText}</div></div></div>`;
    }

    if (elSucesso) {
      elSucesso.innerHTML = html;
      elSucesso.removeAttribute('hidden');
    }
  }

  async function tryAlternativeMethod(zip, country, province, wrapper, contextNote) {
    const form = new URLSearchParams();
    form.append('shipping_address[zip]', zip);
    form.append('shipping_address[country]', country);
    form.append('shipping_address[province]', province);

    const prep = await fetch('/cart/prepare_shipping_rates', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
      body: form
    });
    if (!prep.ok) throw new Error('Prepare failed');

    for (let i = 0; i < 10; i++) {
      await new Promise((r) => setTimeout(r, 1000));
      const r = await fetch('/cart/async_shipping_rates', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (r.status === 200) {
        const json = await r.json();
        if (json && json.shipping_rates && json.shipping_rates.length) {
          renderRates(json, wrapper, contextNote);
          return;
        }
      }
    }
    throw new Error('Timeout polling');
  }

  async function calculateRates(zip, country, province, wrapper, contextNote) {
    const url = `/cart/shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`;
    try {
      const r = await fetch(url, {
        method: 'GET',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' }
      });
      if (!r.ok) throw new Error('fallback');
      const text = await r.text();
      let json;
      try {
        json = JSON.parse(text);
      } catch {
        throw new Error('Resposta inválida');
      }
      renderRates(json, wrapper, contextNote);
    } catch {
      await tryAlternativeMethod(zip, country, province, wrapper, contextNote);
    }
  }

  async function runShippingEstimate(btn) {
    const wrapper = btn && btn.closest && btn.closest('[data-jv-estimativa-frete]');
    if (!wrapper || btn.disabled) return;

    const zipInput = wrapper.querySelector('[data-frete-cep]');
    const zip = (zipInput && zipInput.value ? zipInput.value : '').trim();
    const elDanger = wrapper.querySelector('[data-frete-danger]');
    const elAviso = wrapper.querySelector('[data-frete-aviso]');
    const elSucesso = wrapper.querySelector('[data-frete-sucesso]');
    const includeCart = wrapper.dataset.includeCart !== 'false';

    [elDanger, elAviso, elSucesso].forEach((el) => {
      if (el) {
        el.innerHTML = '';
        el.setAttribute('hidden', 'hidden');
      }
    });

    const originalContent = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = 'Calculando...';

    const cepUnmasked = zip.replace(/\D/g, '');
    const cepRegex = /^[0-9]{8}$/;

    if (!cepRegex.test(cepUnmasked)) {
      if (elAviso) {
        elAviso.innerHTML = '<p class="mb-0">Formato de CEP inválido.</p>';
        elAviso.removeAttribute('hidden');
      }
      btn.innerHTML = originalContent;
      btn.disabled = false;
      return;
    }

    const country = 'BR';
    let province = 'BR';
    let backup = [];

    setCalculating(true);

    try {
      try {
        const respCep = await fetch(`https://brasilapi.com.br/api/cep/v1/${cepUnmasked}`);
        if (respCep.ok) {
          const data = await respCep.json();
          province = data.state || 'BR';
        }
      } catch {
        /* segue sem UF específica */
      }

      backup = await backupCart();
      const productItem = getProductFormData(wrapper);

      if (!productItem) {
        if (elAviso) {
          elAviso.innerHTML = '<p class="mb-0">Não foi possível detectar o produto/variante atual.</p>';
          elAviso.removeAttribute('hidden');
        }
        return;
      }

      let contextNote = '';

      if (includeCart && backup.length > 0) {
        const simulatedCart = buildCartWithProduct(backup, productItem);
        await restoreCart(simulatedCart);
        contextNote = 'Estimativa com os itens do carrinho + este produto';
      } else {
        await fetch('/cart/clear.js', { method: 'POST' });
        await addTemporaryLine(productItem);
      }

      await calculateRates(cepUnmasked, country, province, wrapper, contextNote);
    } catch {
      if (elAviso) {
        elAviso.innerHTML = '<p class="mb-0">Erro ao calcular frete. Tente novamente.</p>';
        elAviso.removeAttribute('hidden');
      }
    } finally {
      try {
        await restoreCart(backup);
      } catch {
        /* falha silenciosa no restore */
      }
      btn.innerHTML = originalContent;
      btn.disabled = false;
      setCalculating(false);
    }
  }

  window.generateShippingRates = runShippingEstimate;

  function initWrapper(wrapper) {
    const zipInput = wrapper.querySelector('[data-frete-cep]');
    const btn = wrapper.querySelector('[data-frete-btn]');
    const form = wrapper.querySelector('.jv-estimativa-frete__form');

    if (zipInput && !zipInput.dataset._mask) {
      zipInput.setAttribute('inputmode', 'numeric');
      zipInput.setAttribute('pattern', '[0-9]*');
      zipInput.setAttribute('autocomplete', 'postal-code');
      zipInput.setAttribute('enterkeyhint', 'search');
      zipInput.dataset._mask = '1';
      zipInput.addEventListener('input', function (e) {
        const v = e.target.value.replace(/\D/g, '');
        e.target.value = v.length > 5 ? `${v.slice(0, 5)}-${v.slice(5, 8)}` : v;
      });
    }

    if (form && !form.dataset._submit) {
      form.dataset._submit = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (!btn?.disabled) runShippingEstimate(btn);
      });
    }

    if (btn && !btn.dataset._click) {
      btn.dataset._click = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!btn.disabled) runShippingEstimate(btn);
      });
    }
  }

  function init() {
    for (const wrapper of document.querySelectorAll('[data-jv-estimativa-frete]')) {
      initWrapper(wrapper);
    }
  }

  if (!window[INIT_FLAG]) {
    window[INIT_FLAG] = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  } else {
    init();
  }
})();
